import axios from "axios";
import * as actionType from "../actionTypes";
import apiConstants from "../../constans/apiConstants";
import { toaster } from "../../utils/utils";

export const fetchPAymentDetails = (pn) => async (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    try {
        const { data } = await axios.get(
        `${
            apiConstants().PROPOSEL_API_URL
        }api/v1/newbilldesk/getOnlinePaymentDetails?proposalNumber=${pn}`,
        {
            headers: {
            authorization: localStorage.getItem("token"),
            },
        }
        );
        dispatch({ type: actionType.LOADER_FALSE })
        if (data.message === "No payment transaction Found") {
            dispatch({
                type: actionType.PAYMENT_MSG,
                payload: data.message,
            })
        } else {
            dispatch({
                type: actionType.PAYMENT_MSG,
                payload: "",
            })
        }
        dispatch({
            type: actionType.PAYMENT_PAYLOAD,
            payload: data.body
        })
    } catch (err) {
        console.log(`err`, err);
        dispatch({ type: actionType.LOADER_FALSE })
    }
};

export const updatePyamentDetailsRowData = (data, cb) => async (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    try {
        const res = await axios.put(`${apiConstants().PROPOSEL_API_URL}api/v1/newbilldesk/updateOnlinePaymentDetails`,
        data,
        {
            headers: {
                authorization: localStorage.getItem("token"),
                },
        }
        )
        dispatch({ type: actionType.LOADER_FALSE })
        console.log(`res`, res);
        if (res && res.data) {
            toaster('success', res.data.message)
        }
        cb && cb();
    } catch (err) {
        console.log(`err`, err)
        dispatch({ type: actionType.LOADER_FALSE })
    }
}

export const getDCRDetails = (pn) => async (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    try {
        const { data } = await axios.post(
        `${
            apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/ops/pushDCRDetails/${pn}`,
        '',
        {
            headers: {
            authorization: localStorage.getItem("token"),
            },
        }
        );
        dispatch({ type: actionType.LOADER_FALSE })
        if(data?.status === 'OK'){
            toaster('success', data.message);
        }else{
            toaster('error', data.message);
        }
    } catch (err) {
        console.log(`err`, err);
        dispatch({ type: actionType.LOADER_FALSE })
    }
};

export const getRCSDetails = (pn) => async (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    try {
        const { data } = await axios.post(
        `${
            apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/ops/swift/ft?proposalNumber=${pn}`,
        '',
        {
            headers: {
            authorization: localStorage.getItem("token"),
            },
        }
        );
        dispatch({ type: actionType.LOADER_FALSE })
        if(data?.status === 'OK'){
            toaster('success', data.message);
        }else{
            toaster('error', data.message);
        }
    } catch (err) {
        console.log(`err`, err);
        dispatch({ type: actionType.LOADER_FALSE })
    }
};
